// source: activity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var user_pb = require('./user_pb.js');
goog.object.extend(proto, user_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.activity.Activities', null, global);
goog.exportSymbol('proto.activity.Activity', null, global);
goog.exportSymbol('proto.activity.ActivityTemplate', null, global);
goog.exportSymbol('proto.activity.ActivityTemplates', null, global);
goog.exportSymbol('proto.activity.Bodypart', null, global);
goog.exportSymbol('proto.activity.Bodyparts', null, global);
goog.exportSymbol('proto.activity.Sporttype', null, global);
goog.exportSymbol('proto.activity.SporttypeBodypart', null, global);
goog.exportSymbol('proto.activity.Sporttypes', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.ActivityTemplates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.activity.ActivityTemplates.repeatedFields_, null);
};
goog.inherits(proto.activity.ActivityTemplates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.ActivityTemplates.displayName = 'proto.activity.ActivityTemplates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.ActivityTemplate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.activity.ActivityTemplate.repeatedFields_, null);
};
goog.inherits(proto.activity.ActivityTemplate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.ActivityTemplate.displayName = 'proto.activity.ActivityTemplate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.Activity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.Activity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.Activity.displayName = 'proto.activity.Activity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.Activities = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.activity.Activities.repeatedFields_, null);
};
goog.inherits(proto.activity.Activities, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.Activities.displayName = 'proto.activity.Activities';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.Sporttypes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.activity.Sporttypes.repeatedFields_, null);
};
goog.inherits(proto.activity.Sporttypes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.Sporttypes.displayName = 'proto.activity.Sporttypes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.Sporttype = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.Sporttype, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.Sporttype.displayName = 'proto.activity.Sporttype';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.Bodypart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.Bodypart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.Bodypart.displayName = 'proto.activity.Bodypart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.Bodyparts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.activity.Bodyparts.repeatedFields_, null);
};
goog.inherits(proto.activity.Bodyparts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.Bodyparts.displayName = 'proto.activity.Bodyparts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.SporttypeBodypart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.SporttypeBodypart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.SporttypeBodypart.displayName = 'proto.activity.SporttypeBodypart';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.activity.ActivityTemplates.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.ActivityTemplates.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.ActivityTemplates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.ActivityTemplates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityTemplates.toObject = function(includeInstance, msg) {
  var f, obj = {
activitietemplatesList: jspb.Message.toObjectList(msg.getActivitietemplatesList(),
    proto.activity.ActivityTemplate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.ActivityTemplates}
 */
proto.activity.ActivityTemplates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.ActivityTemplates;
  return proto.activity.ActivityTemplates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.ActivityTemplates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.ActivityTemplates}
 */
proto.activity.ActivityTemplates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.activity.ActivityTemplate;
      reader.readMessage(value,proto.activity.ActivityTemplate.deserializeBinaryFromReader);
      msg.addActivitietemplates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.ActivityTemplates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.ActivityTemplates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.ActivityTemplates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityTemplates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivitietemplatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.activity.ActivityTemplate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ActivityTemplate activitieTemplates = 1;
 * @return {!Array<!proto.activity.ActivityTemplate>}
 */
proto.activity.ActivityTemplates.prototype.getActivitietemplatesList = function() {
  return /** @type{!Array<!proto.activity.ActivityTemplate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.activity.ActivityTemplate, 1));
};


/**
 * @param {!Array<!proto.activity.ActivityTemplate>} value
 * @return {!proto.activity.ActivityTemplates} returns this
*/
proto.activity.ActivityTemplates.prototype.setActivitietemplatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.activity.ActivityTemplate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.activity.ActivityTemplate}
 */
proto.activity.ActivityTemplates.prototype.addActivitietemplates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.activity.ActivityTemplate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.activity.ActivityTemplates} returns this
 */
proto.activity.ActivityTemplates.prototype.clearActivitietemplatesList = function() {
  return this.setActivitietemplatesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.activity.ActivityTemplate.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.ActivityTemplate.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.ActivityTemplate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.ActivityTemplate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityTemplate.toObject = function(includeInstance, msg) {
  var f, obj = {
templatename: jspb.Message.getFieldWithDefault(msg, 1, ""),
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f),
activitiesList: jspb.Message.toObjectList(msg.getActivitiesList(),
    proto.activity.Activity.toObject, includeInstance),
templateid: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.ActivityTemplate}
 */
proto.activity.ActivityTemplate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.ActivityTemplate;
  return proto.activity.ActivityTemplate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.ActivityTemplate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.ActivityTemplate}
 */
proto.activity.ActivityTemplate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTemplatename(value);
      break;
    case 2:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 3:
      var value = new proto.activity.Activity;
      reader.readMessage(value,proto.activity.Activity.deserializeBinaryFromReader);
      msg.addActivities(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTemplateid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.ActivityTemplate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.ActivityTemplate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.ActivityTemplate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityTemplate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTemplatename();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
  f = message.getActivitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.activity.Activity.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string templateName = 1;
 * @return {string}
 */
proto.activity.ActivityTemplate.prototype.getTemplatename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityTemplate} returns this
 */
proto.activity.ActivityTemplate.prototype.setTemplatename = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional users.UserData user = 2;
 * @return {?proto.users.UserData}
 */
proto.activity.ActivityTemplate.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 2));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.activity.ActivityTemplate} returns this
*/
proto.activity.ActivityTemplate.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.ActivityTemplate} returns this
 */
proto.activity.ActivityTemplate.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.ActivityTemplate.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Activity activities = 3;
 * @return {!Array<!proto.activity.Activity>}
 */
proto.activity.ActivityTemplate.prototype.getActivitiesList = function() {
  return /** @type{!Array<!proto.activity.Activity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.activity.Activity, 3));
};


/**
 * @param {!Array<!proto.activity.Activity>} value
 * @return {!proto.activity.ActivityTemplate} returns this
*/
proto.activity.ActivityTemplate.prototype.setActivitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.activity.Activity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.activity.Activity}
 */
proto.activity.ActivityTemplate.prototype.addActivities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.activity.Activity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.activity.ActivityTemplate} returns this
 */
proto.activity.ActivityTemplate.prototype.clearActivitiesList = function() {
  return this.setActivitiesList([]);
};


/**
 * optional int32 templateId = 4;
 * @return {number}
 */
proto.activity.ActivityTemplate.prototype.getTemplateid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.ActivityTemplate} returns this
 */
proto.activity.ActivityTemplate.prototype.setTemplateid = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.activity.ActivityTemplate} returns this
 */
proto.activity.ActivityTemplate.prototype.clearTemplateid = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.ActivityTemplate.prototype.hasTemplateid = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.Activity.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.Activity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.Activity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.Activity.toObject = function(includeInstance, msg) {
  var f, obj = {
id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f),
sportype: (f = msg.getSportype()) && proto.activity.Sporttype.toObject(includeInstance, f),
parameterone: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
parametertwo: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
tsinsert: (f = msg.getTsinsert()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
score: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.Activity}
 */
proto.activity.Activity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.Activity;
  return proto.activity.Activity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.Activity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.Activity}
 */
proto.activity.Activity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 3:
      var value = new proto.activity.Sporttype;
      reader.readMessage(value,proto.activity.Sporttype.deserializeBinaryFromReader);
      msg.setSportype(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setParameterone(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setParametertwo(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTsinsert(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.Activity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.Activity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.Activity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.Activity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
  f = message.getSportype();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.activity.Sporttype.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTsinsert();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.activity.Activity.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.Activity} returns this
 */
proto.activity.Activity.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.activity.Activity} returns this
 */
proto.activity.Activity.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.Activity.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional users.UserData user = 2;
 * @return {?proto.users.UserData}
 */
proto.activity.Activity.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 2));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.activity.Activity} returns this
*/
proto.activity.Activity.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.Activity} returns this
 */
proto.activity.Activity.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.Activity.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Sporttype sportype = 3;
 * @return {?proto.activity.Sporttype}
 */
proto.activity.Activity.prototype.getSportype = function() {
  return /** @type{?proto.activity.Sporttype} */ (
    jspb.Message.getWrapperField(this, proto.activity.Sporttype, 3));
};


/**
 * @param {?proto.activity.Sporttype|undefined} value
 * @return {!proto.activity.Activity} returns this
*/
proto.activity.Activity.prototype.setSportype = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.Activity} returns this
 */
proto.activity.Activity.prototype.clearSportype = function() {
  return this.setSportype(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.Activity.prototype.hasSportype = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 parameterOne = 4;
 * @return {number}
 */
proto.activity.Activity.prototype.getParameterone = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.Activity} returns this
 */
proto.activity.Activity.prototype.setParameterone = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.activity.Activity} returns this
 */
proto.activity.Activity.prototype.clearParameterone = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.Activity.prototype.hasParameterone = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 parameterTwo = 5;
 * @return {number}
 */
proto.activity.Activity.prototype.getParametertwo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.Activity} returns this
 */
proto.activity.Activity.prototype.setParametertwo = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.activity.Activity} returns this
 */
proto.activity.Activity.prototype.clearParametertwo = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.Activity.prototype.hasParametertwo = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp tsInsert = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.activity.Activity.prototype.getTsinsert = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.activity.Activity} returns this
*/
proto.activity.Activity.prototype.setTsinsert = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.Activity} returns this
 */
proto.activity.Activity.prototype.clearTsinsert = function() {
  return this.setTsinsert(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.Activity.prototype.hasTsinsert = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 score = 7;
 * @return {number}
 */
proto.activity.Activity.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.Activity} returns this
 */
proto.activity.Activity.prototype.setScore = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.activity.Activity} returns this
 */
proto.activity.Activity.prototype.clearScore = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.Activity.prototype.hasScore = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.activity.Activities.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.Activities.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.Activities.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.Activities} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.Activities.toObject = function(includeInstance, msg) {
  var f, obj = {
activitiesList: jspb.Message.toObjectList(msg.getActivitiesList(),
    proto.activity.Activity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.Activities}
 */
proto.activity.Activities.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.Activities;
  return proto.activity.Activities.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.Activities} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.Activities}
 */
proto.activity.Activities.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.activity.Activity;
      reader.readMessage(value,proto.activity.Activity.deserializeBinaryFromReader);
      msg.addActivities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.Activities.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.Activities.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.Activities} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.Activities.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.activity.Activity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Activity activities = 1;
 * @return {!Array<!proto.activity.Activity>}
 */
proto.activity.Activities.prototype.getActivitiesList = function() {
  return /** @type{!Array<!proto.activity.Activity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.activity.Activity, 1));
};


/**
 * @param {!Array<!proto.activity.Activity>} value
 * @return {!proto.activity.Activities} returns this
*/
proto.activity.Activities.prototype.setActivitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.activity.Activity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.activity.Activity}
 */
proto.activity.Activities.prototype.addActivities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.activity.Activity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.activity.Activities} returns this
 */
proto.activity.Activities.prototype.clearActivitiesList = function() {
  return this.setActivitiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.activity.Sporttypes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.Sporttypes.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.Sporttypes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.Sporttypes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.Sporttypes.toObject = function(includeInstance, msg) {
  var f, obj = {
sportypeList: jspb.Message.toObjectList(msg.getSportypeList(),
    proto.activity.Sporttype.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.Sporttypes}
 */
proto.activity.Sporttypes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.Sporttypes;
  return proto.activity.Sporttypes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.Sporttypes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.Sporttypes}
 */
proto.activity.Sporttypes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.activity.Sporttype;
      reader.readMessage(value,proto.activity.Sporttype.deserializeBinaryFromReader);
      msg.addSportype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.Sporttypes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.Sporttypes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.Sporttypes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.Sporttypes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSportypeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.activity.Sporttype.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Sporttype sportype = 1;
 * @return {!Array<!proto.activity.Sporttype>}
 */
proto.activity.Sporttypes.prototype.getSportypeList = function() {
  return /** @type{!Array<!proto.activity.Sporttype>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.activity.Sporttype, 1));
};


/**
 * @param {!Array<!proto.activity.Sporttype>} value
 * @return {!proto.activity.Sporttypes} returns this
*/
proto.activity.Sporttypes.prototype.setSportypeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.activity.Sporttype=} opt_value
 * @param {number=} opt_index
 * @return {!proto.activity.Sporttype}
 */
proto.activity.Sporttypes.prototype.addSportype = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.activity.Sporttype, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.activity.Sporttypes} returns this
 */
proto.activity.Sporttypes.prototype.clearSportypeList = function() {
  return this.setSportypeList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.Sporttype.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.Sporttype.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.Sporttype} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.Sporttype.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
sporttypename: jspb.Message.getFieldWithDefault(msg, 2, ""),
activitytype: jspb.Message.getFieldWithDefault(msg, 3, ""),
parameterone: jspb.Message.getFieldWithDefault(msg, 4, ""),
parametertwo: jspb.Message.getFieldWithDefault(msg, 5, ""),
iconname: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
points: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.Sporttype}
 */
proto.activity.Sporttype.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.Sporttype;
  return proto.activity.Sporttype.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.Sporttype} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.Sporttype}
 */
proto.activity.Sporttype.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSporttypename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivitytype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setParameterone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setParametertwo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setIconname(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.Sporttype.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.Sporttype.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.Sporttype} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.Sporttype.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSporttypename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActivitytype();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getParameterone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getParametertwo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPoints();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.activity.Sporttype.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.Sporttype} returns this
 */
proto.activity.Sporttype.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string sporttypeName = 2;
 * @return {string}
 */
proto.activity.Sporttype.prototype.getSporttypename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.Sporttype} returns this
 */
proto.activity.Sporttype.prototype.setSporttypename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string activityType = 3;
 * @return {string}
 */
proto.activity.Sporttype.prototype.getActivitytype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.Sporttype} returns this
 */
proto.activity.Sporttype.prototype.setActivitytype = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string parameterOne = 4;
 * @return {string}
 */
proto.activity.Sporttype.prototype.getParameterone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.Sporttype} returns this
 */
proto.activity.Sporttype.prototype.setParameterone = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string parameterTwo = 5;
 * @return {string}
 */
proto.activity.Sporttype.prototype.getParametertwo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.Sporttype} returns this
 */
proto.activity.Sporttype.prototype.setParametertwo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string iconName = 6;
 * @return {string}
 */
proto.activity.Sporttype.prototype.getIconname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.Sporttype} returns this
 */
proto.activity.Sporttype.prototype.setIconname = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.activity.Sporttype} returns this
 */
proto.activity.Sporttype.prototype.clearIconname = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.Sporttype.prototype.hasIconname = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 points = 7;
 * @return {number}
 */
proto.activity.Sporttype.prototype.getPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.Sporttype} returns this
 */
proto.activity.Sporttype.prototype.setPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.Bodypart.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.Bodypart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.Bodypart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.Bodypart.toObject = function(includeInstance, msg) {
  var f, obj = {
bodypartname: jspb.Message.getFieldWithDefault(msg, 1, ""),
percentagebodypart: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.Bodypart}
 */
proto.activity.Bodypart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.Bodypart;
  return proto.activity.Bodypart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.Bodypart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.Bodypart}
 */
proto.activity.Bodypart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBodypartname(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPercentagebodypart(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.Bodypart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.Bodypart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.Bodypart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.Bodypart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBodypartname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPercentagebodypart();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string BodypartName = 1;
 * @return {string}
 */
proto.activity.Bodypart.prototype.getBodypartname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.Bodypart} returns this
 */
proto.activity.Bodypart.prototype.setBodypartname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 percentageBodypart = 2;
 * @return {number}
 */
proto.activity.Bodypart.prototype.getPercentagebodypart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.Bodypart} returns this
 */
proto.activity.Bodypart.prototype.setPercentagebodypart = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.activity.Bodyparts.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.Bodyparts.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.Bodyparts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.Bodyparts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.Bodyparts.toObject = function(includeInstance, msg) {
  var f, obj = {
bodypartsList: jspb.Message.toObjectList(msg.getBodypartsList(),
    proto.activity.Bodypart.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.Bodyparts}
 */
proto.activity.Bodyparts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.Bodyparts;
  return proto.activity.Bodyparts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.Bodyparts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.Bodyparts}
 */
proto.activity.Bodyparts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.activity.Bodypart;
      reader.readMessage(value,proto.activity.Bodypart.deserializeBinaryFromReader);
      msg.addBodyparts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.Bodyparts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.Bodyparts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.Bodyparts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.Bodyparts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBodypartsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.activity.Bodypart.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Bodypart bodyparts = 1;
 * @return {!Array<!proto.activity.Bodypart>}
 */
proto.activity.Bodyparts.prototype.getBodypartsList = function() {
  return /** @type{!Array<!proto.activity.Bodypart>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.activity.Bodypart, 1));
};


/**
 * @param {!Array<!proto.activity.Bodypart>} value
 * @return {!proto.activity.Bodyparts} returns this
*/
proto.activity.Bodyparts.prototype.setBodypartsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.activity.Bodypart=} opt_value
 * @param {number=} opt_index
 * @return {!proto.activity.Bodypart}
 */
proto.activity.Bodyparts.prototype.addBodyparts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.activity.Bodypart, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.activity.Bodyparts} returns this
 */
proto.activity.Bodyparts.prototype.clearBodypartsList = function() {
  return this.setBodypartsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.SporttypeBodypart.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.SporttypeBodypart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.SporttypeBodypart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.SporttypeBodypart.toObject = function(includeInstance, msg) {
  var f, obj = {
sporttype: (f = msg.getSporttype()) && proto.activity.Sporttype.toObject(includeInstance, f),
bodyparts: (f = msg.getBodyparts()) && proto.activity.Bodyparts.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.SporttypeBodypart}
 */
proto.activity.SporttypeBodypart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.SporttypeBodypart;
  return proto.activity.SporttypeBodypart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.SporttypeBodypart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.SporttypeBodypart}
 */
proto.activity.SporttypeBodypart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.activity.Sporttype;
      reader.readMessage(value,proto.activity.Sporttype.deserializeBinaryFromReader);
      msg.setSporttype(value);
      break;
    case 2:
      var value = new proto.activity.Bodyparts;
      reader.readMessage(value,proto.activity.Bodyparts.deserializeBinaryFromReader);
      msg.setBodyparts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.SporttypeBodypart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.SporttypeBodypart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.SporttypeBodypart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.SporttypeBodypart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSporttype();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.activity.Sporttype.serializeBinaryToWriter
    );
  }
  f = message.getBodyparts();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.activity.Bodyparts.serializeBinaryToWriter
    );
  }
};


/**
 * optional Sporttype sporttype = 1;
 * @return {?proto.activity.Sporttype}
 */
proto.activity.SporttypeBodypart.prototype.getSporttype = function() {
  return /** @type{?proto.activity.Sporttype} */ (
    jspb.Message.getWrapperField(this, proto.activity.Sporttype, 1));
};


/**
 * @param {?proto.activity.Sporttype|undefined} value
 * @return {!proto.activity.SporttypeBodypart} returns this
*/
proto.activity.SporttypeBodypart.prototype.setSporttype = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.SporttypeBodypart} returns this
 */
proto.activity.SporttypeBodypart.prototype.clearSporttype = function() {
  return this.setSporttype(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.SporttypeBodypart.prototype.hasSporttype = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Bodyparts bodyparts = 2;
 * @return {?proto.activity.Bodyparts}
 */
proto.activity.SporttypeBodypart.prototype.getBodyparts = function() {
  return /** @type{?proto.activity.Bodyparts} */ (
    jspb.Message.getWrapperField(this, proto.activity.Bodyparts, 2));
};


/**
 * @param {?proto.activity.Bodyparts|undefined} value
 * @return {!proto.activity.SporttypeBodypart} returns this
*/
proto.activity.SporttypeBodypart.prototype.setBodyparts = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.SporttypeBodypart} returns this
 */
proto.activity.SporttypeBodypart.prototype.clearBodyparts = function() {
  return this.setBodyparts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.SporttypeBodypart.prototype.hasBodyparts = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.activity);
